const LocalStorageManager = {
    PREFIX: "eventKey_",
    EXPIRE_TIME: 60 * 60 * 1000,
    // EXPIRE_TIME: 1,
    // 1. 데이터 조회 및 동기화 (get)
    get(event){
        const storageKey = `${this.PREFIX}${event.eventKey}`;
        const savedDataStr = localStorage.getItem(storageKey);
        const now = Date.now();

        // 서버 값을 불러와서 로컬스토리지에 저장할 구조 생성
        const serverData = this._buildInitialStructure(event);
        if (savedDataStr) {
            const localData = JSON.parse(savedDataStr);

            // 1. 유효기간(1시간) 만료 체크
            if (localData.updatedAt && now - localData.updatedAt > this.EXPIRE_TIME) {
                this.clear(event.eventKey);
                return this._initAndSave(storageKey, serverData, now);
            }

            // 2. 서버 데이터와 구조적 차이 동기화 (신규 아이템 추가 등)
            return this._syncData(storageKey, localData, serverData);
        }

        // 데이터가 없는 경우 최초 생성
        return this._initAndSave(storageKey, serverData, now);
    },

    // 2. 데이터 업데이트 (update)
    update(eventKey, category, field, newValue, isConfirm = false) {
        const storageKey = `${this.PREFIX}${eventKey}`;
        const data = JSON.parse(localStorage.getItem(storageKey));
        if (!data) return;

        data.updatedAt = Date.now(); // 활동 시간 갱신

        // 경로 탐색 (baskets, items, 혹은 최상위 필드)
        let target;
        if (category) {
            if (!data[category][field]) {
                // 신규 아이템(gift) 등이 추가된 경우 대응
                data[category][field] = { current: newValue, backup: null };
            }
            target = data[category][field];
        } else {
            target = data[field];
        }

        if (isConfirm) {
            target.backup = target.current; // 현재 값을 백업으로
        }
        target.current = newValue; // 새 값을 현재 값으로

        this._save(storageKey, data);
        return data;
    },

    // 3. 초기화 (clear)
    clear(event) {
        const storageKey = `${this.PREFIX}${event.eventKey}`;
        localStorage.removeItem(storageKey);

        // 삭제 직후, 서버 데이터로 깨끗한 상태를 다시 리턴하거나 저장함
        return this.get(event);
    },

    _buildInitialStructure(event) {
        const b = event.baskets?.[0] ?? {};
        const itemMap = {};

        // itemcount만 롤백 대상으로 관리
        (event.items ?? []).forEach(item => {
            itemMap[item.itemkey] = { current: item.itemcount, backup: null };
        });

        return {
            baskets: {
                longitude: { current: b.longitude, backup: null },
                latitude: { current: b.latitude, backup: null },
                distance: { current: b.distance, backup: null },
                maxHP: { current: b.maxHP, backup: null },
                bonusrate: { current: b.bonusrate, backup: null }
            },
            openDate: { current: event.openDate, backup: null },
            startDate: { current: event.startDate, backup: null },
            endDate: { current: event.endDate, backup: null },
            closeDate: { current: event.closeDate, backup: null },
            items: itemMap
        };
    },
    _initAndSave(key, data, time) {
        const finalData = { ...data, updatedAt: time };
        this._save(key, finalData);
        return finalData;
    },

    _syncData(storageKey, localData, serverData) {
        // 서버에 있는데 로컬에 없는 아이템(items) 동기화
        for (const itemKey in serverData.items) {
            if (!localData.items[itemKey]) {
                localData.items[itemKey] = serverData.items[itemKey];
            }
        }
        this._save(storageKey, localData);
        return localData;
    },

    // 특정 필드의 backup만 null로 리셋 (다른 필드 backup 유지)
    resetBackup(eventKey, category, field) {
        const storageKey = `${this.PREFIX}${eventKey}`;
        const data = JSON.parse(localStorage.getItem(storageKey));
        if (!data) return;
        const target = category ? data[category]?.[field] : data[field];
        if (target) target.backup = null;
        this._save(storageKey, data);
    },

    _save(key, data){
        localStorage.setItem(key, JSON.stringify(data));
    },
}

export default LocalStorageManager;